import { useTranslation } from 'react-i18next';

import { hasAggregates } from 'src/components/dashboard/helper';
import useStatisticsDataQuery from 'src/components/dashboard/hooks/useStatisticsDataQuery';

const useStatisticsData = (
  dashboardId?: number,
  filters: Record<string, string[]> = {},
  isEnabled = false,
) => {
  const { t } = useTranslation('common');
  const { data, isFetching, isLoading, error, refetch } =
    useStatisticsDataQuery(isEnabled, dashboardId, filters);
  const loading = isFetching || isLoading;

  const noData = !hasAggregates(data);
  const errorMsg =
    error === 'somethingWentWrong' ? t('somethingWentWrong') : error || '';

  return {
    data,
    loading,
    noData,
    errorMsg,
    refetch,
  };
};

export default useStatisticsData;
